// Plan the visitor picked on the marketing site (`/register?plan=power`). It has
// to survive the onboarding steps between signup and the final "Activate" step,
// where the plan picker lives, so we keep it in sessionStorage — same approach
// as the signup `?ref=` in signup-ref.ts.
import type { Tier } from "@/lib/tier";

const KEY = "prep_signup_plan";
const PLANS: readonly Tier[] = ["essentials", "performance", "power"];

export function sanitizePlan(raw: string | null | undefined): Tier | null {
  const v = (raw ?? "").trim();
  return (PLANS as readonly string[]).includes(v) ? (v as Tier) : null;
}

/**
 * Read `?plan=` on arrival at /register and remember it. A visit with no valid
 * plan clears any earlier pick, so a fresh signup never inherits a stale one.
 */
export function captureSignupPlan(search: string = window.location.search): Tier | null {
  const fromUrl = sanitizePlan(new URLSearchParams(search).get("plan"));
  try {
    if (fromUrl) sessionStorage.setItem(KEY, fromUrl);
    else sessionStorage.removeItem(KEY);
  } catch {
    // storage blocked — the pick just doesn't carry over
  }
  return fromUrl;
}

export function getSignupPlan(): Tier | null {
  try {
    return sanitizePlan(sessionStorage.getItem(KEY));
  } catch {
    return null;
  }
}

export function clearSignupPlan(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
